export default {

	namespaced: true,

	state: {

		data: false

	},

	getters: {

		loggedin: function(state) {

			return state.data !== false

		},

		get: function(state) {

			return state.data

		},

		type: function(state) {

			return state.data.type

		},

		name: function(state) {

			return state.data.firstname + ' ' + state.data.lastname

		}

	},

	mutations: {

		set: function(state, value) {

			state.data = value

		}

	}

}